/*
 * @Description: 问卷相关API
 */
import api from "../service/request";

// 提交问卷（使用 JSON 格式）
export const submitQuestionnaire = (data) => {
  return api({
    url: "/fundtown/ResearchInstitute/AIQuantificationEliteTrainingCampRegistrationQuestionnaire",
    method: "post",
    data, // 直接传递对象，axios 会自动序列化为 JSON
    headers: {
      "Content-Type": "application/json",
    },
  });
};

